var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalendarGroup(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 72,
    height: 33,
    viewBox: "0 0 72 33",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_9",
    "data-name": "Group 9",
    transform: "translate(-298 -212)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_1489",
    "data-name": "Rectangle 1489",
    width: 72,
    height: 33,
    rx: 6,
    transform: "translate(298 212)",
    fill: "#feffff"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Calendar_month",
    "data-name": "Calendar month",
    transform: "translate(339.538 217.538)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557",
    "data-name": "Rectangle 557",
    width: 22,
    height: 22,
    transform: "translate(0.462 0.462)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149",
    "data-name": "Path 149",
    d: "M2.769,6.923V19.385H19.385V6.923ZM18,2.769h2.769a1.308,1.308,0,0,1,1.385,1.385V20.769a1.308,1.308,0,0,1-1.385,1.385H1.385A1.308,1.308,0,0,1,0,20.769V4.154A1.308,1.308,0,0,1,1.385,2.769H4.154V1.385A1.308,1.308,0,0,1,5.538,0,1.308,1.308,0,0,1,6.923,1.385V2.769h8.308V1.385a1.385,1.385,0,1,1,2.769,0ZM16.615,16.615H13.846V13.846h2.769Zm-4.154,0H9.692V13.846h2.769Zm4.154-4.154H13.846V9.692h2.769Zm-4.154,0H9.692V9.692h2.769ZM8.308,16.615H5.538V13.846H8.308Z",
    fill: "#f07615",
    fillRule: "evenodd"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Calendar",
    transform: "translate(306.308 217.538)",
    opacity: 0.583
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_557-2",
    "data-name": "Rectangle 557",
    width: 22,
    height: 22,
    transform: "translate(-0.308 0.462)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_149-2",
    "data-name": "Path 149",
    d: "M2.769,6.923V19.385H19.385V6.923ZM18,2.769h2.769a1.308,1.308,0,0,1,1.385,1.385V20.769a1.308,1.308,0,0,1-1.385,1.385H1.385A1.308,1.308,0,0,1,0,20.769V4.154A1.308,1.308,0,0,1,1.385,2.769H4.154V1.385A1.308,1.308,0,0,1,5.538,0,1.308,1.308,0,0,1,6.923,1.385V2.769h8.308V1.385a1.385,1.385,0,1,1,2.769,0Z",
    transform: "translate(0 0)",
    fill: "#f07615",
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("text", {
    id: "_365",
    "data-name": 365,
    transform: "translate(10.692 14.462)",
    fill: "#f07615",
    fontSize: 8,
    fontFamily: "Roboto-Black, Roboto",
    fontWeight: 800
  }, /*#__PURE__*/React.createElement("tspan", {
    x: -6.949,
    y: 0
  }, "365"))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarGroup);
export default __webpack_public_path__ + "static/media/CalendarGroup.b6eb9b42f593493c99864f8be726de7f.svg";
export { ForwardRef as ReactComponent };